// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-7078a076] .van-tabbar-item__icon img {
  height: auto;
}
.safe-area[data-v-7078a076] {
  height: calc(50px + env(safe-area-inset-bottom));
  /* padding-bottom: env(safe-area-inset-bottom); */
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
